import TextItem, { TextItemProps } from './TextItem';

export type { TextItemProps };
export default TextItem;
